// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 밴드QR 출력 페이지 (테스트 전용) */

.band-qr-print-page {
  min-height: 100vh;
  background: #0f172a;
  color: #e2e8f0;
  display: flex;
  flex-direction: column;
}

.bqp-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #1e293b;
}

.bqp-header h1 {
  flex: 1 1;
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.bqp-back {
  background: #1e293b;
  color: #e2e8f0;
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 15px;
  cursor: pointer;
}

.bqp-badge {
  background: #7c2d12;
  color: #fed7aa;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
}

.bqp-body {
  flex: 1 1;
  max-width: 520px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.bqp-label {
  font-size: 15px;
  color: #94a3b8;
}

.bqp-count-input {
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  padding: 16px;
  border-radius: 12px;
  border: 2px solid #334155;
  background: #1e293b;
  color: #f8fafc;
}

.bqp-count-input:focus {
  outline: none;
  border-color: #f97316;
}

.bqp-print-btn {
  font-size: 20px;
  font-weight: 700;
  padding: 18px;
  border-radius: 12px;
  border: none;
  background: #f97316;
  color: #fff;
  cursor: pointer;
}

.bqp-print-btn:disabled {
  background: #475569;
  cursor: not-allowed;
}

.bqp-result {
  border-radius: 12px;
  padding: 16px;
  font-size: 16px;
}

.bqp-result.bqp-ok {
  background: #052e16;
  border: 1px solid #16a34a;
  color: #bbf7d0;
}

.bqp-result.bqp-err {
  background: #450a0a;
  border: 1px solid #dc2626;
  color: #fecaca;
}

.bqp-result-msg {
  margin: 0;
  font-weight: 600;
}

.bqp-codes {
  margin-top: 12px;
  font-size: 13px;
}

.bqp-codes summary {
  cursor: pointer;
  color: #94a3b8;
}

.bqp-codes ul {
  margin: 8px 0 0;
  padding-left: 18px;
  max-height: 220px;
  overflow-y: auto;
  font-family: monospace;
  color: #cbd5e1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/BandQrPrintPage.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":["/* 밴드QR 출력 페이지 (테스트 전용) */\n\n.band-qr-print-page {\n  min-height: 100vh;\n  background: #0f172a;\n  color: #e2e8f0;\n  display: flex;\n  flex-direction: column;\n}\n\n.bqp-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #1e293b;\n}\n\n.bqp-header h1 {\n  flex: 1;\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.bqp-back {\n  background: #1e293b;\n  color: #e2e8f0;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.bqp-badge {\n  background: #7c2d12;\n  color: #fed7aa;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: 999px;\n}\n\n.bqp-body {\n  flex: 1;\n  max-width: 520px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 32px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.bqp-label {\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.bqp-count-input {\n  font-size: 32px;\n  font-weight: 700;\n  text-align: center;\n  padding: 16px;\n  border-radius: 12px;\n  border: 2px solid #334155;\n  background: #1e293b;\n  color: #f8fafc;\n}\n\n.bqp-count-input:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.bqp-print-btn {\n  font-size: 20px;\n  font-weight: 700;\n  padding: 18px;\n  border-radius: 12px;\n  border: none;\n  background: #f97316;\n  color: #fff;\n  cursor: pointer;\n}\n\n.bqp-print-btn:disabled {\n  background: #475569;\n  cursor: not-allowed;\n}\n\n.bqp-result {\n  border-radius: 12px;\n  padding: 16px;\n  font-size: 16px;\n}\n\n.bqp-result.bqp-ok {\n  background: #052e16;\n  border: 1px solid #16a34a;\n  color: #bbf7d0;\n}\n\n.bqp-result.bqp-err {\n  background: #450a0a;\n  border: 1px solid #dc2626;\n  color: #fecaca;\n}\n\n.bqp-result-msg {\n  margin: 0;\n  font-weight: 600;\n}\n\n.bqp-codes {\n  margin-top: 12px;\n  font-size: 13px;\n}\n\n.bqp-codes summary {\n  cursor: pointer;\n  color: #94a3b8;\n}\n\n.bqp-codes ul {\n  margin: 8px 0 0;\n  padding-left: 18px;\n  max-height: 220px;\n  overflow-y: auto;\n  font-family: monospace;\n  color: #cbd5e1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
